<template>
  <div class="slope-chart-skeleton">
    <div class="slope-chart-loader-content">
      <SlopeChartThreeLines v-if="numberOfLines === 3" />
      <SlopeChartFiveLines v-else />
      <div class="legend-wrapper">
        <div
          v-for="line in numberOfLines"
          :key="line"
          class="legend-item"
        >
          <v-skeleton-loader type="heading" width="16" />
          <v-skeleton-loader type="heading" width="50" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import SlopeChartThreeLines from '@/assets/slope-chart-3-lines.svg?component';
import SlopeChartFiveLines from '@/assets/slope-chart-5-lines.svg?component';

defineProps({
  numberOfLines: {
    type: Number,
    default: 3,
  },
  width: {
    type: String,
    default: '100%',
  },
  height: {
    type: String,
    default: '100%',
  },
});
</script>

<style scoped lang="less">
.slope-chart-skeleton {
  width: v-bind(width);
  height: v-bind(height);
}

.slope-chart-loader-content {
  display: flex;
  align-items: flex-start;
  max-height: 100%;
}

.legend-wrapper {
  margin-top: 20px;
  margin-left: 12px;
}

.legend-item {
  display: flex;
  gap: 8px;
  margin-bottom: 6px;
}

:deep(.v-skeleton-loader__heading) {
  margin: 0px;
  height: 16px;
  border-radius: 4px;
}
</style>
